import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import policyData from "../../stripeElakayPolicie.json";
import Layout from "../Layout/Layout";
import { 

    getAddressById, 
    isAuthenticated, 
    getOrderWalletSeller, 
    getOrderWalletAdmin, 
    getElakayIncomme,
    getOrderPayRoll
} from "../auth";
import Form from 'react-bootstrap/Form'
import Accordion from 'react-bootstrap/Accordion'
import Modal from 'react-bootstrap/Modal'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { getListBankAccounts, CreatBankAccounts, ListaccountsOrcreateStripeAccount, listePM_createStripeCusTomer, updateCustomer, DeletePaymentMethod, updatePayment, CustomersRetrieve, postCreateTransfer, createStripeAccount, retrieveStripeAccount, getListExternalAccounts, DeleteBankAccounts, UpdateBankAccounts, DeleteBankAccountsExternal, UpdateBankAccountsExternal, AccountLinks } from "../auth/stripe"
import StripeError from "../pageInside/StripeError"
import CardSetupForm from "../pageInside/Stripe/stripeIndex";
import { getSafeReturnUrl } from "../../utils/userAddingRoleToken";
import EditSetupForm from "../pageInside/Stripe/editCardForm";
import Table from 'react-bootstrap/Table';
import { Family, 
        Adminstrator, 
        Investment,
        Assoociate,
        Provider,
        Seller,
        CommercialRole,
    } from "../pageInside/Rolle"
import StripeAccountCreationModal from '../pageInside/Stripeaccountcreationmodal.jsx';
import Price from "../pageInside/productsPrice"
import FormBC from "../pageInside/FormBC"
import FormEBC from "../pageInside/FormEBC"
import BusinessForm from "../pageInside/FormBusiness"
import IncomePrice from "../pageInside/incomePrice"
import IncomeTotalPrice from "../pageInside/incomeTotalPrice"
import { AiFillBank } from "react-icons/ai";
import { FaCheck, FaCreditCard, FaChartLine } from "react-icons/fa";
import { laguangeElakay, getElakayLanguageContext } from "../pageInside/dataElakay";
import CreditCardType from "../pageInside/creditCardType"
import FiltersIncomme from "../pageInside/filtersIncomme";
import TransferMoneyModal from "../pageInside/TransferMoneyModal";
import Paymentmethodsredesign from "../pageInside/Paymentmethodsredesign.jsx";
import AssociatePaymentDashboard from "../pageInside/Associatepaymentdashboard.jsx";
import Associateincomedashboard from "../pageInside/Associateincomedashboard.jsx";
import {
    elakayFraisJSON,
    ItemsOrder,
    prodDiscount,
    prodPrice,
    prodFrService, 
    prodFrVente,
    prodFrRef,
    prodDisAdmin,
    TaxOrder,
    getTotal,
    prodFrTransaction,
    totalFrais,
    inComeSeller,
    elakayFrais,
    calProfit
} from '../auth/allPriceFeet'
import notPayment from '../Layout/icon/notPayment.gif'
import notPayment1 from '../Layout/icon/notPayment.jpeg'
import StripeElakayPolicyPage from "../pageInside/StripeElakayPolicyPage";
import StripeBankAccountsPage from "../pageInside/StripeBankAccountsPage";
import WalletBankingOverview from "../pageInside/WalletBankingOverview";
import WalletBalancePanel from "../pageInside/payments/WalletBalancePanel";
import { elakayAutoText } from "../pageInside/dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["wallet"]?.[key] || fallback;

const WALLET_TABS = ["payment", "banking", "income"];
const WALLET_INCOME_VIEWS = {
  sales: "MyOrdersAsSeller",
  "seller-commissions": "MySellerOrders",
  promotions: "MyPromoOrders",
  "role-income": "MyOrderIncome"
};
const WALLET_INCOME_VIEW_SLUGS = Object.entries(WALLET_INCOME_VIEWS).reduce(
  (views, [slug, view]) => ({ ...views, [view]: slug }),
  {}
);

const getWalletTabFromSearch = (search = "") => {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search);
  const requestedTab = params.get("tab");

  if (WALLET_TABS.includes(requestedTab)) return requestedTab;
  if (params.get("bkl") === "true") return "banking";
  return "payment";
};

const getWalletIncomeViewFromSearch = (search = "") => {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search);
  return WALLET_INCOME_VIEWS[params.get("view")] || "MyOrdersAsSeller";
};

const walletPagesForTab = (tab) => ({
  paymentL: tab === "payment",
  bankingL: tab === "banking",
  incommeL: tab === "income"
});

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const sumAll = (salesIncome, sellerCommission, sellerPromotion, buyerCommission) => {
  // convertit proprement int ou string → number
  const toNumber = (val) => {
    const num = Number(val);
    return isNaN(num) ? 0 : num;   // sécurité
  };

  const seller = toNumber(salesIncome);
  const commission = toNumber(sellerCommission);
  const buyer = toNumber(buyerCommission);
  const promo = toNumber(sellerPromotion);

  return {
    salesIncome: seller.toFixed(2),
    sellerCommission: commission.toFixed(2),
    sellerPromotion : promo.toFixed(2),
    buyerCommission: buyer.toFixed(2),
    total: Number((seller + commission + buyer + promo).toFixed(2))
  };
}

const paymentIntentIncomeTotal = (orders = []) =>
  orders.reduce((total, order) => {
    const amount = Number(order?.incomeAmount);
    return total + (Number.isFinite(amount) ? amount : 0);
  }, 0);

const clearAddCardFromURL = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("addCard");
  window.history.replaceState({}, "", url.pathname + url.search);
};
const Wallet = (props) => {
    const {
        infoSource
        } = props
    __setElakayInfoSource(infoSource);

   const location = useLocation();
   const query = useQuery();
   const navigate = useNavigate();
   const checkoutReturnUrl = getSafeReturnUrl(query.get("returnUrl"));

        let filorder = {
            roneName : [
                        "Family",
                        "Administrator",
                        "Investment",
                        "Associate",
                        "Provider",
                        "Seller",
                        "Royalty"
                        ],
            orderStatus: [
                        "Not processed",
                        "Processing",
                        "Shipped",
                        "Delivered",
                        "Cancelled",
                        "Return Back"
        ],
         OrdersReadyToPay: false,
            orderDate: 'months',
            limit: 50,
            myd: 6,
            asc: 'desc'
        }
    const [limit, setLimit] = useState(30);
    const [skip, setSkip] = useState(0);
    const [sizeOrders, setSizeOrders] = useState(0);
    const [filtOrders, setFiltOrders] = useState(filorder);
    const [showFilterOrder, setShowFilterOrder] = useState(false);
    const [showFilterOrder_, setShowFilterOrder_] = useState(false);      

    const [loading, setLoading] = useState(true);
    const [incomeLoading, setIncomeLoading] = useState(true);
    const [incomeError, setIncomeError] = useState("");
    const [loadingB, setLoadingB] = useState(false);  
    const [AddBankAcc, setAddBankAcc] = useState(false);
    const [AddExBankAcc, setAddExBankAcc] = useState(false);
    const [transferMoneyShow, setTransferMoneyShow] = useState(false);
    const [withdrawSignal, setWithdrawSignal] = useState(0);
    const [addCards, setAddCards] = useState(false);
    const [cardSaveSuccess, setCardSaveSuccess] = useState("");
    const [bankAccountsList, setBankAccountsList] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [editCardsInfo, setEditCardsInfo] = useState();
    const [editCards, setEditCards] = useState(false);
    const [editBankAcc, setEditBankAcc] = useState(false);
    const [editBankAccInfo, setEditBankAccInfo] = useState();
    const [editBankHolderName, setEditBankHolderName] = useState("");
    const [show, setShow] = useState(false);
    const [customersRe, setCustomersRe] = useState([]);
    const [walletSeller, setWalletSeller] = useState([]);
    const [my_Order_as_Seller, setMy_Order_as_Seller] = useState([]);
    const [my_Seller_Order, setMy_Seller_Order] = useState([]);
    const [my_Commision_Orders, setMy_Commision_Orders] = useState([]);
    const [my_Promo_Orders, setMy_Promo_Orders] = useState([]);
    const [commisionUser, setCommisionUser] = useState([]);
    const [paymentSeller, setPaymentSeller] = useState([]);
    const [paymentAdmin, setPaymentAdmin] = useState([]);
    const [getACCStripe, setACCStripe] = useState([]);
    const [countrySel, setcountrySel] = useState("US");
    const [incommeView, setIncommeView] = useState(() =>
      getWalletIncomeViewFromSearch(location.search)
    );
    const { token } = isAuthenticated();
    const [showStripeModal, setShowStripeModal] = useState(false);
    const [showPolicyModal, setShowPolicyModal] = useState(false);
    const langCode = "en"; // ou "en", "es", "ht", "pt"
    const userType = "seller"; // ou "client"

    const [pagesWallet, setPagesWallet] = useState(() =>
      walletPagesForTab(getWalletTabFromSearch(location.search))
    )
    const {
        paymentL,
        bankingL,
        incommeL
        } = pagesWallet

        const {
            readUser,
            address,
            userInfo,
            allDisabled
        }= infoSource

    // La source des revenus est pilotée par AnimationSettings.
    const usePaymentIntentIncome =
        infoSource?.allSettings?.wallet?.usePaymentIntentIncome === true;
    const paymentIntentSummary =
        walletSeller?.data?.summary || walletSeller?.summary;

    const handleChartDateRangeChange = useCallback((dateRange) => {
        setFiltOrders((current) => {
            const next = {
                ...current,
                ...dateRange,
                limit: "Endless"
            };

            return JSON.stringify(current) === JSON.stringify(next)
                ? current
                : next;
        });
    }, []);

        const {
            StripeCustomerId, 
          setupIntentId
           } = userInfo
const incommeList = ['Incomme as Seller', 'Incomme for my Seller', 'Incomme for my Provider', 'Incomme for my Associate', 'Incomme for my Investment', 'Incomme for my Administrator', "Developer income", 'all Incomme']
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tab = getWalletTabFromSearch(params);
  const view = getWalletIncomeViewFromSearch(params);
  const expectedView = WALLET_INCOME_VIEW_SLUGS[view];
  const needsCanonicalUrl =
    params.get("tab") !== tab ||
    params.has("bkl") ||
    (tab === "income" && params.get("view") !== expectedView) ||
    (tab !== "income" && params.has("view"));

  setPagesWallet(walletPagesForTab(tab));
  setIncommeView(view);

  // Canonicalise les anciens liens et rend l'onglet actif explicite dans l'URL.
  if (needsCanonicalUrl) {
    params.set("tab", tab);
    params.delete("bkl");
    if (tab === "income") {
      params.set("view", expectedView);
    } else {
      params.delete("view");
    }
    navigate(
      { pathname: location.pathname, search: params.toString() },
      { replace: true }
    );
  }
}, [location.pathname, location.search, navigate]);
    useEffect(() => {
        query.get("addCard") && setAddCards(true)
        Customercreate(token)
    //   loadExternalAccounts(token)
        loadCustomersRetrieve(token)
        laodbankAccountsList(token)

        // laodOrderWalletAdminMonney()
        // laodOrderWalletSellerMonney()
        laodAdminPaymentOrder()
        laodSellerPaymentOrder()
        AccountStripe()
    }, []);

  useEffect(() => {
    // laodOrderWalletAdmin(orderStatus)
        laodOrderWalletSeller(token, filtOrders)
    }, [filtOrders, usePaymentIntentIncome]);

    const AccountStripe = () => {
              CommercialRole() && (
            retrieveStripeAccount(token).then(data => {
                if (data.error) {
                } else {
                    setACCStripe(data)
                }
            })
        )
    }
    // const laodOrderWalletSellerMonney =()=>{
    //     CommercialRole() && (
    //         getOrderWalletSeller(token, "Delivered").then(data =>{
    //             if (data.error) {
    //             } else {
    //                 setWalletSellMonney(data)

    //             }
    //         })
    //     )
    // }

    // const laodOrderWalletAdminMonney = () => {
    //     Adminstrator() && (
    //         getOrderWalletAdmin(token, "Delivered").then(data => {
    //             if (data.error) {
    //             } else {
    //                 setWalletAdminMonney(data)

    //             }
    //         })
    //     )
    // }

    const laodOrderWalletSeller = (token, filtOrders) => {
        if (!token) {
            setIncomeLoading(false)
            return
        }

        setIncomeLoading(true)
        setIncomeError("")
        getElakayIncomme(token, skip, filtOrders, usePaymentIntentIncome)
            .then(response => {
                if (response?.error || response?.success === false) {
                    setIncomeError(response?.error || elakayAutoText("h_inc_load_error", "Unable to load income data."))
                    return
                }

                const payload = response?.data || response
                const incomeData = payload?.data || {}
                setMy_Order_as_Seller(
                    payload?.My_Order_as_Seller || incomeData?.mySellerOrders || []
                )
                setMy_Seller_Order(
                    payload?.My_Seller_Order || incomeData?.myReferrerSellerOrders || []
                )
                setMy_Commision_Orders(
                    payload?.My_Order_incomme || {
                        detail: incomeData?.myRoleIncomeOrders || [],
                        totalBaseRate: payload?.summary?.roleIncome?.totalAmount || 0
                    }
                )
                setMy_Promo_Orders(
                    payload?.My_Promo || {
                        detail: incomeData?.myPromotionOrders || [],
                        totalPromoRate: payload?.summary?.promotion?.totalAmount || 0
                    }
                )
                setWalletSeller(response)
            })
            .catch(error => {
                setIncomeError(error?.message || elakayAutoText("h_inc_load_error", "Unable to load income data."))
            })
            .finally(() => setIncomeLoading(false))
    }

const loadOrderPayRoll = (token, filtOrders) => {
    token && (
        getOrderPayRoll(token, skip, filtOrders).then(data => {
            if (data.error) {
                // setShow(true);   // affiche ton modal d’erreur
            } else {
                // setCommisionUser(data);
                // setOrderPayRoll(data); // sauvegarde les données
            }
        })
    );
};

    const laodAdminPaymentOrder = () => {
        CommercialRole() && (
            getOrderWalletSeller(token, "Delivered", true).then(data => {
                if (data.error) {
                } else {
                    setPaymentSeller(data)

                }
            })
        )
    }

    const laodSellerPaymentOrder = () => {
        Adminstrator() && (
            getOrderWalletAdmin(token, "Delivered", true).then(data => {
                if (data.error) {
                } else {
                    setPaymentAdmin(data)

                }
            })
            )
    }

    
    const AccountStripeCreate = (values) => {
        setLoadingB(true)
          CommercialRole() && (
            createStripeAccount(token, values).then(data => {
                if (data.error) {
                } else {
                   
                    readUser(token)
                    setLoadingB(false)
                }
            }));

    };


    const Customercreate = async (token, { showGlobalError = true } = {}) => {
        if (!token) return { success: false, error: "Authentication is required." };
        const data = await listePM_createStripeCusTomer(token);
        if (data.error || data.success === false) {
            setLoading(false);
            showGlobalError && userInfo?.StripeCustomerId && setShow(true);
        } else {
            setPaymentMethods(data);
            setLoading(false);
        }
        return data;
    };




    const laodbankAccountsList = (token) => {
        token && (
            getListBankAccounts(token).then(data => {
                if (data.error) {
                    setShow(true)
                } else {
                    setBankAccountsList(data)
                }
            }));

    };

    const loadCustomersRetrieve = (token) => {
        token && (
            CustomersRetrieve(token).then(data => {
                if (data.error) {
                   userInfo?.StripeCustomerId && setShow(true)
                } else {
                    setCustomersRe(data)
                }
            }));

    };
      
 const loadExternalAccounts = (token) => {
    getListExternalAccounts(token).then(data => {
            if (data.error) {
                    setShow(true)
                } else {
                     setBankAccountsList(data)
                }

    })
  };

    const buttonDefaultCard = (PM_id)=>{
        token && (
        updateCustomer(token, { invoice_settings: { default_payment_method: PM_id }},  "default_payment_method").then(data => {
            if (data.error) {
            } else {
                Customercreate(token)
            }
        })
        )
    }

    const DelPaymentMethod = (PM_id) => {
       
            DeletePaymentMethod(token, {PM_id}).then(data => {
                if (data.error) {
                } else {
                    Customercreate(token)
                }
            });

    };
    const AccountBank = (token) => {
        token && (
            CreatBankAccounts(token).then(data => {
                if (data.error) {
                } else {
                    setACCStripe(data)
                }
            })
        )
    }

    const DelBankAccount = (id) => {
        token && (
            DeleteBankAccounts(token, { id }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else {
                    laodbankAccountsList(token)
                }
            })
        )
    }

    const UpdateBankAccount = (id, info) => {
        token && (
            UpdateBankAccounts(token, { id, ...info }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else {
                    laodbankAccountsList(token)
                }
            })
        )
    }

    const DelExternalBankAccount = (id) => {
        token && (
            DeleteBankAccountsExternal(token, { id }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else {
                    AccountStripe()
                }
            })
        )
    }

    const SetDefaultExternalBankAccount = (id) => {
        token && (
            UpdateBankAccountsExternal(token, { id, default_for_currency: true }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else {
                    AccountStripe()
                }
            })
        )
    }

    const UpdateExternalBankAccount = (id, info) => {
        token && (
            UpdateBankAccountsExternal(token, { id, ...info }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else {
                    AccountStripe()
                }
            })
        )
    }

    const EditAccountLink = () => {
        token && (
            AccountLinks(token, { type: "account_update" }).then(data => {
                if (data.error) {
                    window.alert(data.error)
                } else if (data.url) {
                    window.location.href = data.url
                }
            })
        )
    }

    const ButtonEdit =(CV, K)=>{
        setEditCards(K)
        setEditCardsInfo(CV)

    }

    const ButtonEditBank = (CV) => {
        setEditBankAccInfo(CV)
        setEditBankHolderName(CV?.billing_details?.name || "")
        setEditBankAcc(true)
    }

    const SaveEditBank = () => {
        if (!editBankAccInfo?.id) return;
        UpdateBankAccount(editBankAccInfo.id, { billing_details: { name: editBankHolderName } });
        setEditBankAcc(false)
    }


   const cardSCreditDetail =()=>(
       paymentMethods?.paymentMethods?.length > 0 ? (
       <div style={{ overflow: "auto" }}>
           <h5>{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).cards}</h5>
        <Accordion>
               {
               
                   paymentMethods?.paymentMethods?.map((CV, i)=>(

                       <Accordion.Item key={i} eventKey={CV.id}>
                             <Accordion.Header>
                          
                                   <h6 className="m-0 p-0">{`${CV?.brand}  ....${CV?.last4}--`}</h6>
                                   <p className="m-0 p-0">{elakayAutoText("h_449ff0d2162f5c", "Expires {value0}/{value1}", { value0: CV?.exp_month, value1: CV?.exp_year })}</p>     
                                   <h5 className="m-0 p-0 pl-3"> {paymentMethods.defaultPaymentMethodId === CV.id && <FaCheck /> }</h5> 
                            </Accordion.Header>
                   
                           <Accordion.Body>
                               <>
                          <div className="row">
                            <div className="col col-12 col-md-6" >
                                <CreditCardType
                                    cardsDetail ={CV.card}
                                    last4 = {CV?.last4}
                                    brand = {CV?.brand}
                                    exp_month = {CV?.exp_month}
                                    exp_year =  {CV?.exp_year}
                                    name={CV?.name}
                                    infoSource={infoSource}
                                   />
                              </div>
                            <div className="col col-12 col-md-6" >
                                           <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).billingAddress}</h4>
                                           <h6>{CV?.name}</h6>
                                           <h6>{CV.billing_details.address.line1}</h6>
                                           <h6>{CV.billing_details.address.city}</h6>
                                           <h6>{`${CV.billing_details.address.state}, ${CV.billing_details.address.country}, ${CV.billing_details.address.postal_code}`}</h6>

                            </div>

                          </div> 
                            <div className="row mt-2">
                            <div className="col col-12 col-md-7" >
                                           <Button variant="primary btn-md rounded-4" onClick={() => DelPaymentMethod(CV.id)}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).delete}</Button>
                                           <Button variant="primary btn-md rounded-4" onClick={() => ButtonEdit(CV, true)}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).edit}</Button>
                                </div>  
                                       <div className="col col-12 col-md-5" >
                                           <Link to="#" variant="link" onClick={() => buttonDefaultCard(CV.id)}>{infoSource.laguangeElakay('Link', infoSource.languageAPI).setDefault}</Link>
                                       </div>
                          </div>
                         
                          </>
                           </Accordion.Body>
                       </Accordion.Item>
                   ))
               }
           </Accordion>
       </div>
       ):
        
                       <div className="shadow-lg mt-3 mb-3">
                           <img
                               className="rounded"
                               src={notPayment1}
                               alt={__elakayText("t019", "no Product")}
                               style={{ height: "100%", width: "100%" }}
                           />
                       </div>
   )

    const banksDetailList = () => (
        bankAccountsList?.length > 0 && ( 
            <div style={{ overflow: "auto" }}>
                <h5>{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).banks}</h5>
                {
                    bankAccountsList?.map((CV, i) => (
                        <div key={i} className="p-1 mb-1 bg-light">
                            <AiFillBank className="m-2 h2"/>
                            <span className="h6">{CV.us_bank_account?.bank_name} </span>
                            <span> ...{CV.us_bank_account?.last4}</span>

                            <div className="row mt-2">
                                <div className="col col-12 col-md-7" >
                                    <Button variant="primary" onClick={() => DelBankAccount(CV.id)}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).delete}</Button>
                                    <Button variant="primary" onClick={() => ButtonEditBank(CV)}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).edit}</Button>
                                </div>
                                <div className="col col-12 col-md-5" >
                                    <Link to={"#"} variant="link" onClick={() => UpdateBankAccount(CV.id, { set_default: true })}>{infoSource.laguangeElakay('Link', infoSource.languageAPI).setDefault}</Link>
                                </div>
                            </div>
                        </div>
                    ))}
 
            </div>
        )
    )



    const closeAddCardModal = () => {
        setAddCards(false);
        clearAddCardFromURL();
    };

    const handleCardSaved = (message) => {
        setCardSaveSuccess(message);
        loadCustomersRetrieve(token);
        if (checkoutReturnUrl) navigate(checkoutReturnUrl, { replace: true });
    };

    const PaymentStri = () => (
        <CardSetupForm
            infoSource={infoSource}
            address={address}
            token={token}
            getAddressById={getAddressById}
            setAddCards={setAddCards}
            Customercreate={Customercreate}
            clearAddCardFromURL={clearAddCardFromURL}
            setupIntentClientSecret={paymentMethods?.setupIntent?.client_secret}
            onSuccess={handleCardSaved}
            onCancel={closeAddCardModal}
        />
    )

    const AddBankAccount = () => (
        <div className="contaire">
            <div className="row justify-content-center " >
                <Modal
                    size="lg"
                    show={AddBankAcc}
                    onHide={() => setAddBankAcc(false)}
                    dialogClassName="modal-90w"
                    centered
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h2>{infoSource.laguangeElakay('title', infoSource.languageAPI).addBankAccount}</h2>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {formSelect()}
                        <FormBC
                            laguangeElakay={laguangeElakay}
                            infoSource ={infoSource}
                            countrySel = {countrySel}
                            setAddBankAcc={setAddBankAcc}
                            isAuthenticated={isAuthenticated}
                            setcountrySel={setcountrySel}
                            onSuccess={() => laodbankAccountsList(token)}
                        />
                      
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
    const AddExBankAccount = () => (
        <div className="contaire">
            <div className="row justify-content-center " >
                <Modal
                    size="lg"
                    show={AddExBankAcc}
                    onHide={() => setAddExBankAcc(false)}
                    dialogClassName="modal-90w"
                    centered
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h2>{infoSource.laguangeElakay('title', infoSource.languageAPI).addExBankAccoounts}</h2>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {formSelect()}
                        <FormEBC
                            laguangeElakay={laguangeElakay}
                            infoSource ={infoSource}
                            countrySel={countrySel}
                            setAddExBankAcc={setAddExBankAcc}
                            isAuthenticated={isAuthenticated}
                            setcountrySel={setcountrySel}
                            onSuccess={() => AccountStripe()}
                        />

                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )

    const transferMoney = () => (
        <><style>
          {`
          .wallet-menu-wrapper {
            display: flex;
            justify-content: center;
            margin: 1.5rem auto 2rem;
            padding: 0 1rem;
          }

          .wallet-menu {
            width: 100%;
            max-width: 1100px;
            padding: 8px;
            border: 1px solid #dbe7ee;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.88);
            box-shadow: 0 12px 35px rgba(15, 65, 82, 0.08);
            backdrop-filter: blur(14px);
          }

          .wallet-menu-title {
            font-weight: 600;
            font-size: 1.1rem;
            margin-bottom: 0.75rem;
          }

          .wallet-menu-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 8px;
          }

          @media (max-width: 480px) {
            .wallet-menu-grid {
              grid-template-columns: 1fr;
            }
          }

          .wallet-menu-item {
            background: #ffffff;
            border-radius: 12px;
            padding: 12px 14px;
            text-align: center;
            cursor: pointer;
            border: 1px solid #e3e3e3;
            box-shadow: 0 1px 3px rgba(0,0,0,0.06);
            transition: all 0.25s ease;
            font-size: 0.95rem;
            font-weight: 500;
            color: #333;
          }

          .wallet-menu-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(0,0,0,0.12);
            border-color: #2f855a;
          }

          .wallet-menu-item.payment {
            border-left: 4px solid #3182ce;
          }

          .wallet-menu-item.banking {
            border-left: 4px solid #805ad5;
          }

          .wallet-menu-item.income {
            border-left: 4px solid #2f855a;
          }

          .wallet-menu-item-label {
            margin: 0;
          }

          .wallet-menu-filters {
            margin-top: 0.75rem;
            display: flex;
            justify-content: flex-end;
          }

          .wallet-menu-filters button {
            border-radius: 999px;
            padding-inline: 18px;
            font-size: 0.9rem;
          }
              .tracking-close-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 10;
            background: #fff;
            border: none;
            font-size: 1.5rem;
            line-height: 1;
            color: #333;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            cursor: pointer;
          }

          .tracking-close-btn:hover {
            background-color: #f5f5f5;
          }
        `}
      </style>
            <div className="row justify-content-center " >
                <Modal
                    // size="dm"
                    show={transferMoneyShow}
                    onHide={() => setTransferMoneyShow(false)}
                  centered
                  dialogClassName="tracking-modal"
                  contentClassName="tracking-modal-content"
                  aria-labelledby="example-custom-modal-styling-title"
                  >
                             <button
          className="tracking-close-btn"
          onClick={() => setTransferMoneyShow(false)}
          aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t001}
        >
          ×
        </button>
        
    <TransferMoneyModal 
        infoSource={infoSource}
        commisionUser={commisionUser}
        sellerPromotion={usePaymentIntentIncome
            ? Number(paymentIntentSummary?.promotion?.totalAmount) || 0
            : my_Promo_Orders.totalPromoRate}
        buyerCommission={usePaymentIntentIncome
            ? Number(paymentIntentSummary?.roleIncome?.totalAmount) || 0
            : my_Commision_Orders?.totalBaseRate}
        sellerCommission={usePaymentIntentIncome
            ? Number(paymentIntentSummary?.referrerSeller?.totalAmount) || 0
            : elakayFraisJSON(my_Seller_Order)?.payAddONSeller}
        salesIncome={usePaymentIntentIncome
            ? Number(paymentIntentSummary?.seller?.totalAmount) || 0
            : elakayFraisJSON(my_Order_as_Seller)?.inComeSeller}
        setFiltOrders={setFiltOrders}
        sumAll={sumAll}
        setShowFilterOrder={setShowFilterOrder_}
        onCancel={() => setTransferMoneyShow(false)}
        onTransfer={() => {
            // The legacy summary never executed anything: the real
            // withdrawal (server-side balance, 7-day rule, provider
            // confirmation) is the Wallet "Withdraw Money" flow.
            setTransferMoneyShow(false)
            selectWalletTab("banking")
            setWithdrawSignal((n) => n + 1)
        }}

        />
     {showFilterOrder_ && <div className="p-4 bg-light">
           <FiltersIncomme 
         laguangeElakay={laguangeElakay}
         infoSource ={infoSource}
         limit={parseInt(limit)}
         setLimit= {setLimit}
         setFiltOrders={setFiltOrders}
         setShowFilterOrder={setShowFilterOrder}
         filtOrders={filtOrders}
        />
        </div>}
                </Modal>
            </div>
        </>
    )

    const SaveCard = () => {
        const cardText = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.cardSetupForm;

        return (
            <Modal
                show={addCards}
                onHide={closeAddCardModal}
                dialogClassName="wallet-payment-modal"
                contentClassName="wallet-payment-modal__content"
                centered
                scrollable
                aria-labelledby="wallet-payment-modal-title"
                aria-describedby="wallet-payment-modal-subtitle"
            >
                <Modal.Header className="wallet-payment-modal__header" closeButton>
                    <div className="wallet-payment-modal__heading">
                        <span className="wallet-payment-modal__icon" aria-hidden="true"><FaCreditCard /></span>
                        <div>
                            <Modal.Title id="wallet-payment-modal-title" as="h2" className="wallet-payment-modal__title">
                                {infoSource.laguangeElakay('title', infoSource.languageAPI).addPaymentMethods}
                            </Modal.Title>
                            <p id="wallet-payment-modal-subtitle" className="wallet-payment-modal__subtitle">
                                {cardText?.modalSubtitle || "Add your card information securely."}
                            </p>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="wallet-payment-modal__body">
                    {PaymentStri()}
                </Modal.Body>
            </Modal>
        );
    }

    const countryChange = () => event => {
        const value = event.target.value;
        setcountrySel(value)
    }

    const formSelect = () => (
        <div className="row justify-content-center m-4" >
            <div className="col col-12 col-md-8 col-lg-8 col-xl-6 p-2" style={{ border: "1px solid WhiteSmoke" }}>
                <Form>
                    <Form.Group controlId="exampleForm.SelectCustom">
                        <Form.Label>{infoSource.laguangeElakay('label', infoSource.languageAPI).customSelect}</Form.Label>
                        <Form.Select onChange={countryChange()} value={countrySel} aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t002}>
                        <option value="" >{infoSource.laguangeElakay('label', infoSource.languageAPI).selCountry}</option>
                        <option value="CA">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t003}</option>
                        <option  value="US">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t004}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </div></div>
    )

    const EditCard = () => (
        <div className="contaire">
            <div className="row justify-content-center " >
                <Modal
                    size="lg"
                    show={editCards}
                    onHide={() => setEditCards(false)}
                    dialogClassName="modal-90w"
                    centered
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h2>{infoSource.laguangeElakay('title', infoSource.languageAPI).editCards}</h2>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mt-4 mb-4 justify-content-center">
                            <div className="col col-12 col-md-11 col-lg-10 col-xl-9" style={{ border: "1px solid Gainsboro" }} >
                                <EditSetupForm 
                                    laguangeElakay={laguangeElakay}
                                    infoSource ={infoSource}
                                    address={address}
                                    token={token}
                                    getAddressById={getAddressById}
                                    setEditCards={setEditCards}
                                    Customercreate={Customercreate}
                                    updatePayment={updatePayment}
                                    PM={editCardsInfo}
                                />
                              
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )

    const EditBankAccount = () => (
        <div className="contaire">
            <div className="row justify-content-center " >
                <Modal
                    size="lg"
                    show={editBankAcc}
                    onHide={() => setEditBankAcc(false)}
                    dialogClassName="modal-90w"
                    centered
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h2>{infoSource.laguangeElakay('Button', infoSource.languageAPI).edit}</h2>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mt-4 mb-4 justify-content-center">
                            <div className="col col-12 col-md-11 col-lg-10 col-xl-9" style={{ border: "1px solid Gainsboro" }} >
                                <div className="form-group">
                                    <label className="text-muted">{infoSource.laguangeElakay('label', infoSource.languageAPI).accountName}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={editBankHolderName}
                                        onChange={(e) => setEditBankHolderName(e.target.value)}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <Button variant="outline-primary" onClick={() => setEditBankAcc(false)}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel}</Button>
                                    <Button variant="primary" className="ml-2" onClick={SaveEditBank}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).saveBank}</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )

    const updateWalletUrl = useCallback((tab, view) => {
        const params = new URLSearchParams(location.search);
        params.set("tab", tab);
        params.delete("bkl");

        if (tab === "income") {
            const safeView = WALLET_INCOME_VIEW_SLUGS[view]
                ? view
                : "MyOrdersAsSeller";
            params.set("view", WALLET_INCOME_VIEW_SLUGS[safeView]);
        } else {
            params.delete("view");
        }

        navigate({ pathname: location.pathname, search: params.toString() });
    }, [location.pathname, location.search, navigate]);

    const selectWalletTab = (tab) => {
        const nextTab = WALLET_TABS.includes(tab) ? tab : "payment";
        const nextView = nextTab === "income" ? incommeView : undefined;
        setPagesWallet(walletPagesForTab(nextTab));
        updateWalletUrl(nextTab, nextView);
    };

    const selectIncomeView = (view) => {
        const nextView = WALLET_INCOME_VIEW_SLUGS[view]
            ? view
            : "MyOrdersAsSeller";
        setIncommeView(nextView);
        setPagesWallet(walletPagesForTab("income"));
        updateWalletUrl("income", nextView);
    };

    const ButtonPaymentL = () => selectWalletTab("payment");
    const ButtonBankingL = () => selectWalletTab("banking");
    const ButtonIncommeL = () => selectWalletTab("income");

    let StyleMenu0 = {
        borderLeft: "1px solid lightgrey",
        borderRight: "1px solid lightgrey",
        borderBottom: "None",
        backgroundColor: "GhostWhite"
    }

    let StyleMenu = {
        borderBottom: "6px solid Gainsboro",
        backgroundColor: "AliceBlue"
    }

    let paymentStyle = paymentL ? StyleMenu : StyleMenu0

    let bankingStyle = bankingL ? StyleMenu : StyleMenu0

    let incommeStyle = incommeL ? StyleMenu : StyleMenu0

    const WalletMenu_ = () => (

        <div className="row mt-4 mb-4 justify-content-center">
            <div className="col col-12 col-md-10 col-lg-9 col-xl-8 p-0" >
                <div className="col col-12 col-md-12" style={{ textAlign: "center"}}>
                    <div className="row">
                        <div className="col col-12 col-md-4" style={paymentStyle} onClick={ButtonPaymentL}>
                            <p className="m-2">{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).setUpPayments}</p>
                        </div>
                        {CommercialRole() && (
                            <>
                        <div className="col col-12 col-md-4" style={bankingStyle} onClick={ButtonBankingL}>
                            <p className="m-2">{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).BankingPayouts}</p>
                        </div>
                        <div className="col col-12 col-md-4" style={incommeStyle} onClick={ButtonIncommeL}>
                            <p className="m-2">{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).viewIncomePayout}</p>
                        </div>
                        </>
                        )}
                </div>

                </div>
         {  incommeL && <div className="col col-12 col-md-12" >
            <div className="btn btn-dark btn-md py-1 rounded-4" onClick={()=>setShowFilterOrder(true)}>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t005}</div> 
        </div>}
            </div>
            
        </div>
    )

const WalletMenu = () => {
  const isSeller = CommercialRole();

  return (
    <>
      {/* 🎨 CSS intégré */}
      <style>
        {`
          .wallet-menu-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .wallet-menu {
            width: 100%;
            max-width: 960px;
          }

          .wallet-menu-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 0.75rem;
          }

          @media (max-width: 768px) {
            .wallet-menu-grid {
              grid-template-columns: 1fr;
            }
          }

          .wallet-menu-item {
            appearance: none;
            width: 100%;
            background: transparent;
            border-radius: 13px;
            padding: 14px 16px;
            text-align: left;
            cursor: pointer;
            border: 1px solid transparent;
            transition: all 0.25s ease;
            color: #415565;
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .wallet-menu-item:hover {
            background: #f3f9fc;
            border-color: #cce3ed;
            color: #006f93;
          }

          .wallet-active {
            background: linear-gradient(135deg, #007399, #009bc5) !important;
            border-color: #007399 !important;
            color: #fff !important;
            box-shadow: 0 8px 22px rgba(0, 115, 153, 0.24) !important;
          }

          .wallet-menu-item-icon {
            width: 38px;
            height: 38px;
            flex: 0 0 38px;
            border-radius: 11px;
            display: grid;
            place-items: center;
            background: #e8f4f8;
            color: #007399;
            font-size: 17px;
          }

          .wallet-active .wallet-menu-item-icon {
            color: #fff;
            background: rgba(255,255,255,.18);
          }

          .wallet-menu-item-label {
            margin: 0;
            font-size: .93rem;
            font-weight: 750;
            line-height: 1.2;
          }

          .wallet-menu-item-copy small {
            display: block;
            margin-top: 4px;
            color: #7c8f9b;
            font-size: .72rem;
            font-weight: 500;
          }

          .wallet-active .wallet-menu-item-copy small {
            color: rgba(255,255,255,.78);
          }

          .wallet-menu-filters {
            margin-top: 0.75rem;
            display: flex;
            justify-content: flex-end;
          }

          .wallet-menu-filters button {
            border-radius: 999px;
            padding-inline: 18px;
            font-size: 0.9rem;
          }
        `}
      </style>

      {/* 🌐 CONTENU */}
      <div className="wallet-menu-wrapper">
        <div className="wallet-menu">
          <div className="wallet-menu-grid" role="tablist" aria-label={__elakayText("t022", "Wallet sections")}>
            {/* Setup Payments */}
            <button
              type="button"
              className={`wallet-menu-item payment ${paymentL ? "wallet-active" : ""}`}
              onClick={ButtonPaymentL}
              role="tab"
              aria-selected={paymentL}
            >
              <span className="wallet-menu-item-icon"><FaCreditCard /></span>
              <span className="wallet-menu-item-copy">
                <span className="wallet-menu-item-label">{infoSource.laguangeElakay("walletPage", infoSource.languageAPI).setUpPayments}</span>
                <small>{__elakayText("t019", "Cards and payment methods")}</small>
              </span>
            </button>
            
            {/* Banking + Income : seulement si Seller */}
            {isSeller && <>
                <button
                  type="button"
                  className={`wallet-menu-item banking ${bankingL ? "wallet-active" : ""}`}
                  onClick={ButtonBankingL}
                  role="tab"
                  aria-selected={bankingL}
                >
                  <span className="wallet-menu-item-icon"><AiFillBank /></span>
                  <span className="wallet-menu-item-copy">
                    <span className="wallet-menu-item-label">{infoSource.laguangeElakay("walletPage", infoSource.languageAPI).BankingPayouts}</span>
                    <small>{__elakayText("t020", "Balances, banks and withdrawals")}</small>
                  </span>
                </button>

                <button
                  type="button"
                  className={`wallet-menu-item income ${incommeL ? "wallet-active" : ""}`}
                  onClick={ButtonIncommeL}
                  role="tab"
                  aria-selected={incommeL}
                >
                  <span className="wallet-menu-item-icon"><FaChartLine /></span>
                  <span className="wallet-menu-item-copy">
                    <span className="wallet-menu-item-label">{infoSource.laguangeElakay("walletPage", infoSource.languageAPI).viewIncomePayout}</span>
                    <small>{__elakayText("t021", "Reports, charts and transactions")}</small>
                  </span>
                </button>
              </>}
          </div>

          {/* Bouton Filters si incommeL = true */}
          {incommeL && (
            <div className="wallet-menu-filters">
              <button
                className="btn btn-dark btn-sm py-1"
                onClick={() => setShowFilterOrder(true)}
              >{__elakayText("t005", "Filters")}</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};


    const UserDetails = () => (
        paymentL && (
        <div className="row mt-4 mb-4 justify-content-center">
            <div className="col col-12 col-md-10 col-lg-9 col-xl-8 p-0" style={{ border: "1px solid Gainsboro" }} >
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).addMethPayment}</h3>
                </div>
                
                    {cardSCreditDetail()}

                    {banksDetailList()}

                <button onClick={() => setAddCards(true)} className="btn btn-dark btn-md py-2 m-4 rounded-4 float-right">
                   {infoSource.laguangeElakay('Button', infoSource.languageAPI).addCard}
                </button>
                    <button className="btn btn-outline-primary m-4 float-left">
                        <span onClick={() => setAddBankAcc(true)}> {infoSource.laguangeElakay('Button', infoSource.languageAPI).addBank}</span>
                    </button>
            </div>
        </div>
     ) )

                const mockAccount = {
  id: "acct_1SAMPLE123",
  email: "seller@example.com",
  business_type: "individual",
  payouts_enabled: true,
  capabilities: {
    transfers: "active",
    card_payments: "active",
  },
};

const mockBanks = [
  {
    id: "ba_1",
    bank_name: "Bank of America",
    last4: "4242",
    routing_number: "110000000",
    country: "US",
    currency: "usd",
    status: "verified",
    default_for_currency: true,
    billing_address: {
      name: __elakayText("t018", "full name ....yvox"),
      line1: "226 Norfeld BLVD",
      city: "Elmont",
      state: "NY",
      postal_code: "11003",
      country: "US",
    },
  },
]
const legacyOrGroupedIncomePayroll = sumAll(
    usePaymentIntentIncome
        ? paymentIntentIncomeTotal(my_Order_as_Seller)
        : elakayFraisJSON(my_Order_as_Seller)?.inComeSeller,
    usePaymentIntentIncome
        ? paymentIntentIncomeTotal(my_Seller_Order)
        : elakayFraisJSON(my_Seller_Order)?.payAddONSeller,
    my_Promo_Orders.totalPromoRate,
    my_Commision_Orders?.totalBaseRate
)

const paymentIntentIncomeSummary = walletSeller?.PaymentIntentIncome;
const incommePayroll =
    usePaymentIntentIncome && paymentIntentIncomeSummary
        ? {
            ...legacyOrGroupedIncomePayroll,
            total: Number(paymentIntentIncomeSummary.totalAmount) || 0
        }
        : legacyOrGroupedIncomePayroll;
    
const UserDetailsDD = () => (
        CommercialRole() &&  bankingL && (
            <>
        <div className="row mt-4 mb-4 justify-content-center">
            <div className="col col-12 col-md-10 col-lg-9 col-xl-8 p-0">
                    {/* <h1>{PaymentWallet(paymentSeller, paymentAdmin)}</h1> */}

                    <WalletBankingOverview
                        infoSource={infoSource}
                        hasStripeAccount={Boolean(userInfo?.stripeAccountsId)}
                        incomeAvailable={incommePayroll?.total}
                        incomePending={null}
                        payoutsEnabled={getACCStripe?.payouts_enabled}
                        chargesEnabled={getACCStripe?.charges_enabled}
                        payoutHistory={[]}
                    />

            <div style={{ border: "1px solid Gainsboro" }} >
               {userInfo?.stripeAccountsId
               ?<> 
               <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).setUpPayments}</h3>
                
                {/* {getACCStripe.length > 0?<> */}

<StripeBankAccountsPage
  account={getACCStripe}
  banks={getACCStripe.external_accounts?.data || []}
  infoSource={infoSource}
  onDeleteBank={DelExternalBankAccount}
  onSetDefaultBank={SetDefaultExternalBankAccount}
  onUpdateBank={UpdateExternalBankAccount}
/>
                {/* </>: 
                <>
                </>
                } */}
        
            </div>
               <button onClick={() => setAddExBankAcc(true)} className="btn btn-dark btn-md py-2 m-3 rounded-4 float-left">
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).addBank}
                </button>
                 <button onClick={() => setTransferMoneyShow(true)}  className="btn btn-dark btn-md m-3 py-2 rounded-4 float-left">
                  {infoSource.laguangeElakay('Button', infoSource.languageAPI).transfer}
                </button>
                </>
                :
                <>
                <BusinessForm
          AccountStripeCreate={AccountStripeCreate}
          infoSource ={infoSource}
          loadingB={loadingB}
           address={address}
           token={token}
          />
                <button className="btn btn-dark btn-md py-2 m-3 rounded-4 float-left disabled">
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).addBank}
                </button>
                  <button   className="btn btn-dark btn-md m-3 py-2 rounded-4 float-left disabled">
                  {infoSource.laguangeElakay('Button', infoSource.languageAPI).transfer}
                </button>
                </>
                }
            </div>
            </div>
        </div>
        </>
    ))

    const MonneyWalletViewSell = () =>
  CommercialRole() &&
  incommeL && (
    <>
      {/* 🎨 CSS intégré pour une belle présentation */}
      <style>
        {`
          .wallet-sell-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .wallet-sell-card {
            width: 100%;
            max-width: 1100px;
            border: 1px solid Gainsboro;
            border-radius: 12px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          }

          .wallet-sell-header {
            text-align: center;
            background: linear-gradient(90deg, #f5f5f5, #e9f3ff);
            padding: 10px 8px;
          }

          .wallet-sell-header h3 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: 600;
            color: #333;
          }

          .wallet-sell-table-container {
            overflow: auto;
            padding: 6px 8px 10px 8px;
          }

          .wallet-sell-table thead th {
            position: sticky;
            top: var(--elakay-header-height, 90px);
            background-color: #f8fafc !important;
            z-index: 1;
            font-size: 0.85rem;
            text-align: center;
            white-space: nowrap;
          }

          .wallet-sell-table tbody td,
          .wallet-sell-table tbody th {
            font-size: 0.85rem;
            padding: 4px 6px !important;
            vertical-align: middle;
            text-align: center;
          }

          .wallet-sell-table tfoot td {
            font-weight: 600;
            background-color: #f9fafb;
          }

          .wallet-sell-total-label {
            text-align: right;
            font-weight: 600;
          }

          .wallet-sell-amount {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          }
        `}
      </style>

      <div className="wallet-sell-wrapper">
        <div className="wallet-sell-card">
          <div className="wallet-sell-header">
            <h3>
              {
                infoSource.laguangeElakay(
                  "walletPage",
                  infoSource.languageAPI
                ).viewincommeSell
              }
            </h3>
          </div>

          <div className="wallet-sell-table-container">
            <Table
              striped
              bordered
              hover
              size="sm"
              className="wallet-sell-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).name
                    }
                  </th>
                  {/* <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).count
                    }
                  </th> */}
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).productPrice
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).productSale
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).incomeSeller
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).transFeet
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).feet
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).totalFeet
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).profit
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).loss
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).statut
                    }
                  </th>
                </tr>
              </thead>

              <tbody>
                {my_Order_as_Seller?.map((order, i) => (
                  <tr key={order._id || i}>
                    <td>{i + 1}</td>

                    <td><span  dangerouslySetInnerHTML={{ __html: order.prod_name.substring(0, 22)+'...'}}></span></td>

                    {/* <td>{order.products.count}</td> */}

                    <td className="wallet-sell-amount">
                      <Price
                        showAddToCartButton={false}
                        products={{
                          price: order.products.price,
                          salePrice: order.products.salePrice
                        }}
                      />
                    </td>

                    <td className="wallet-sell-amount">
                      {getTotal([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    <td className="wallet-sell-amount">
                      {inComeSeller([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    <td className="wallet-sell-amount">
                      {prodFrTransaction([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    <td className="wallet-sell-amount">
                      {elakayFrais([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    <td className="wallet-sell-amount">
                      {totalFrais([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    <td className="wallet-sell-amount">
                      {calProfit([order], 0, order.prod_costPrice).profit?.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD"
                        }
                      )}
                    </td>

                    <td className="wallet-sell-amount">
                      {calProfit([order], 0, order.prod_costPrice).loss?.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD"
                        }
                      )}
                    </td>

                    <td className="wallet-sell-amount">
                      {calProfit([order], 0, order.prod_costPrice).statut}
                    </td>
                  </tr>
                ))}

                {/* Ligne TOTAL */}
                <tr>
                  <td />
                  <td />
                  <td className="wallet-sell-total-label">{__elakayText("t010", "TOTAL:")}</td>

                  <td className="wallet-sell-amount">
                    {ItemsOrder(my_Order_as_Seller)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  <td className="wallet-sell-amount">
                    {getTotal(my_Order_as_Seller)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  <td className="wallet-sell-amount">
                    {inComeSeller(my_Order_as_Seller)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  <td className="wallet-sell-amount">
                    {prodFrTransaction(my_Order_as_Seller)?.toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD"
                      }
                    )}
                  </td>

                  <td className="wallet-sell-amount">
                    {elakayFrais(my_Order_as_Seller)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  <td className="wallet-sell-amount">
                    {totalFrais(my_Order_as_Seller)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  <td colSpan={3} />
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );

  const CommissionForMySeller = () =>
  CommercialRole() &&
  incommeL && (
    <>
      {/* 🎨 CSS intégré */}
      <style>
        {`
          .commission-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .commission-card {
            width: 100%;
            max-width: 1100px;
            border: 1px solid Gainsboro;
            border-radius: 12px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          }

          .commission-header {
            text-align: center;
            background: linear-gradient(90deg, #f5f5f5, #e9f3ff);
            padding: 10px 8px;
          }

          .commission-header h3 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: 600;
            color: #333;
          }

          .commission-header p {
            margin: 2px 0 0 0;
            font-size: 0.85rem;
            color: #555;
          }

          .commission-table-container {
            overflow: auto;
            padding: 6px 8px 10px 8px;
          }

          .commission-table thead th {
            position: sticky;
            top: var(--elakay-header-height, 90px);
            background-color: #f8fafc !important;
            z-index: 1;
            font-size: 0.85rem;
            text-align: center;
            white-space: nowrap;
          }

          .commission-table tbody td,
          .commission-table tbody th {
            font-size: 0.85rem;
            padding: 4px 6px !important;
            vertical-align: middle;
            text-align: center;
          }

          .commission-table tfoot td {
            font-weight: 600;
            background-color: #f9fafb;
          }

          .commission-total-label {
            text-align: right;
            font-weight: 600;
          }

          .commission-amount {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          }
        `}
      </style>

      <div className="commission-wrapper">
        <div className="commission-card">
          <div className="commission-header">
            <h3>
              {/* Titre multilingue ou phrase simple */}
              {infoSource?.laguangeElakay
                ? infoSource.laguangeElakay("walletPage", infoSource.languageAPI)
                    .commissionForMySeller || "Commission for my sellers"
                : elakayAutoText("h_abeb1823e67433", "Commission for my sellers")}
            </h3>
            <p>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t006}</p>
          </div>

          <div className="commission-table-container">
            <Table
              striped
              bordered
              hover
              size="sm"
              className="commission-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {infoSource.laguangeElakay(
                      "walletPage",
                      infoSource.languageAPI
                    ).name || "Name"}
                  </th>
                  <th>
                    {infoSource.laguangeElakay(
                      "walletPage",
                      infoSource.languageAPI
                    ).productPrice || "Product price"}
                  </th>
                  <th>
                    {infoSource.laguangeElakay(
                      "sellPage",
                      infoSource.languageAPI
                    ).productSale || "Product sale"}
                  </th>
                  <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t007}</th>
                  <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t008}</th>
                  <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t009}</th>
                </tr>
              </thead>

              <tbody>
                {my_Seller_Order?.map((order, i) => (
                  <tr key={order._id || i}>
                    {/* # */}
                    <td>{i + 1}</td>

                    {/* Name */}
                    <td>{order.prod_name}</td>

                    {/* Product price */}
                    <td className="commission-amount">
                      <Price
                        showAddToCartButton={false}
                        products={{
                          price: order.products.price,
                          salePrice: order.products.salePrice
                        }}
                      />
                    </td>

                    {/* Product sale (total for that order) */}
                    <td className="commission-amount">
                      {getTotal([order])?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    {/* My fee 1/3 */}
                    <td className="commission-amount">
                      {elakayFraisJSON([order])?.payAddONSeller?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    {/* Elakay fee 2/3 */}
                    <td className="commission-amount">
                      {elakayFraisJSON([order])?.payElakay?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    {/* Total fee 6% */}
                    <td className="commission-amount">
                      {elakayFraisJSON([order])?.totalWithoutFixedFee?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>
                  </tr>
                ))}

                {/* Ligne TOTAL */}
                <tr>
                  <td />
                  <td rowspan="2" className="commission-total-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t010}</td>

                  {/* Total product price */}
                  <td className="commission-amount">
                    {ItemsOrder(my_Seller_Order)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  {/* Total product sale */}
                  <td className="commission-amount">
                    {getTotal(my_Seller_Order)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  {/* Total my fee 1/3 */}
                  <td className="commission-amount">
                    {elakayFraisJSON(my_Seller_Order)?.payAddONSeller?.toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD"
                      }
                    )}
                  </td>

                  {/* Total Elakay fee 2/3 */}
                  <td className="commission-amount">
                    {elakayFraisJSON(my_Seller_Order)?.payElakay?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  {/* Total fee 6% */}
                  <td className="commission-amount">
                    {elakayFraisJSON(my_Seller_Order)?.totalWithoutFixedFee?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );

const CommissionFromOrders = () =>
  CommercialRole() &&
  incommeL && (
    <>
      {/* 🎨 CSS intégré */}
      <style>
        {`
          .commission-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .commission-card {
            width: 100%;
            max-width: 900px;
            border: 1px solid Gainsboro;
            border-radius: 12px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          }

          .commission-header {
            text-align: center;
            background: linear-gradient(90deg, #f5f5f5, #e9f3ff);
            padding: 10px 8px;
          }

          .commission-header h3 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: 600;
            color: #333;
          }

          .commission-header p {
            margin: 2px 0 0 0;
            font-size: 0.85rem;
            color: #555;
          }

          .commission-table-container {
            overflow: auto;
            padding: 6px 8px 10px 8px;
          }

          .commission-table thead th {
            position: sticky;
            top: var(--elakay-header-height, 90px);
            background-color: #f8fafc !important;
            z-index: 1;
            font-size: 0.85rem;
            text-align: center;
            white-space: nowrap;
          }

          .commission-table tbody td,
          .commission-table tbody th {
            font-size: 0.85rem;
            padding: 4px 6px !important;
            vertical-align: middle;
            text-align: center;
          }

          .commission-table tfoot td {
            font-weight: 600;
            background-color: #f9fafb;
          }

          .commission-total-label {
            text-align: right;
            font-weight: 600;
          }

          .commission-amount {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          }
        `}
      </style>

      <div className="commission-wrapper">
        <div className="commission-card">
          <div className="commission-header">
            <h3>
              {/* Tu peux brancher ta langue ici si tu veux */}
              {infoSource?.laguangeElakay
                ? infoSource.laguangeElakay("walletPage", infoSource.languageAPI)
                    .commissionFromOrders || "Commission from orders"
                : elakayAutoText("h_ea2f4e384a993c", "Commission from orders")}
            </h3>
            <p>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t011}</p>
          </div>

          <div className="commission-table-container">
            <Table
              striped
              bordered
              hover
              size="sm"
              className="commission-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).name
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).productSale
                    }
                  </th>
                  <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t012}</th>
                </tr>
              </thead>

              <tbody>
                {my_Commision_Orders?.detail?.map((order, i) => (
                  <tr key={order._id || i}>
                    {/* # */}
                    <td>{i + 1}</td>

                    {/* name */}
                    <td>{order.prod_name}</td>

                    {/* product sale */}
                    <td className="commission-amount">
                      {order?.amountTotal?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    {/* commission order (ici j’utilise totalFrais([order]) = 6%) */}
                    <td className="commission-amount">
                      {order?.baseRate?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>
                  </tr>
                ))}

                {/* Ligne TOTAL */}
                <tr>
                  <td />
                  <td className="commission-total-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t013}</td>

                  {/* Total product sale */}
                  <td className="commission-amount">
                    {my_Commision_Orders?.totalAmountEligible?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  {/* Total commission orders */}
                  <td className="commission-amount">
                    {my_Commision_Orders?.totalBaseRate?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );

const MyPromotionOrders = () =>
  CommercialRole() &&
  incommeL && (
    <>
      {/* 🎨 CSS intégré */}
      <style>
        {`
          .promo-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .promo-card {
            width: 100%;
            max-width: 900px;
            border: 1px solid Gainsboro;
            border-radius: 12px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          }

          .promo-header {
            text-align: center;
            background: linear-gradient(90deg, #f5f5f5, #e9f3ff);
            padding: 10px 8px;
          }

          .promo-header h3 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: 600;
            color: #333;
          }

          .promo-header p {
            margin: 2px 0 0 0;
            font-size: 0.85rem;
            color: #555;
          }

          .promo-table-container {
            overflow: auto;
            padding: 6px 8px 10px 8px;
          }

          .promo-table thead th {
            position: sticky;
            top: var(--elakay-header-height, 90px);
            background-color: #f8fafc !important;
            z-index: 1;
            font-size: 0.85rem;
            text-align: center;
            white-space: nowrap;
          }

          .promo-table tbody td,
          .promo-table tbody th {
            font-size: 0.85rem;
            padding: 4px 6px !important;
            vertical-align: middle;
            text-align: center;
          }

          .promo-table tfoot td {
            font-weight: 600;
            background-color: #f9fafb;
          }

          .promo-total-label {
            text-align: right;
            font-weight: 600;
          }

          .promo-amount {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          }
        `}
      </style>

      <div className="promo-wrapper">
        <div className="promo-card">
          <div className="promo-header">
            <h3>
              {infoSource?.laguangeElakay
                ? infoSource.laguangeElakay("walletPage", infoSource.languageAPI)
                    .myPromotionOrders || "My promotion orders"
                : elakayAutoText("h_d804fa310fdbc4", "My promotion orders")}
            </h3>
            <p>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t014}</p>
          </div>

          <div className="promo-table-container">
            <Table
              striped
              bordered
              hover
              size="sm"
              className="promo-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "walletPage",
                        infoSource.languageAPI
                      ).name
                    }
                  </th>
                  <th>
                    {
                      infoSource.laguangeElakay(
                        "sellPage",
                        infoSource.languageAPI
                      ).productSale
                    }
                  </th>
                  <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t015}</th>
                </tr>
              </thead>

              <tbody>
                {my_Promo_Orders?.detail?.map((order, i) => (
                  <tr key={order._id || i}>
                    {/* # */}
                    <td>{i + 1}</td>

                    {/* name */}
                    <td>{order.prod_name}</td>

                    {/* product sale */}
                    <td className="promo-amount">
                      {order?.amountTotal?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>

                    {/* Promo order */}
                    <td className="promo-amount">
                      {order?.promoRate?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })}
                    </td>
                  </tr>
                ))}

                {/* Ligne TOTAL */}
                <tr>
                  <td />
                  <td className="promo-total-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t016}</td>

                  {/* Total product sale */}
                  <td className="promo-amount">
                    {my_Promo_Orders?.totalAmountPromo?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>

                  {/* Total Promo order */}
                  <td className="promo-amount">
                    {my_Promo_Orders?.totalPromoRate?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD"
                    })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );


    const PaymentWallet = (seller, admin) => {
        let priceSell
        let priceAdmin
        let total
        Seller ?
            priceSell = seller.reduce((currentValue, nextValue) => {
                return currentValue + (nextValue.count * 0.97 * (nextValue.price * (100 - nextValue.salePrice) / 100))
            }, 0)
            :
            priceSell = 0

        Adminstrator ?
            priceAdmin = admin.reduce((currentValue, nextValue) => {
                return currentValue + (nextValue.count * 0.33 * 0.03 * (nextValue.price * (100 - nextValue.salePrice) / 100))
            }, 0)
            :
            priceAdmin = 0

        total = priceSell + priceAdmin

        return <span className="text-muted">
            {(total)?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}
        </span>

    }

    const filterOrdersView = ()=>{
        return <Modal
        size="md"
        show={showFilterOrder}
        onHide={() => setShowFilterOrder(false)}
        // dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
            <h2>
                {/* Orders Filters */}
                {infoSource.language(infoSource, "title", "ordFilt")}
                </h2>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <FiltersIncomme 
         laguangeElakay={laguangeElakay}
         infoSource ={infoSource}
         limit={parseInt(limit)}
         setLimit= {setLimit}
         setFiltOrders={setFiltOrders}
         setShowFilterOrder={setShowFilterOrder}
         filtOrders={filtOrders}
        />

        </Modal.Body>
    </Modal>

    }
const sellerMenu = [
  { key: "MyOrdersAsSeller", icon: "🛒" },
  { key: "MySellerOrders", icon: "📦" },
  { key: "MyPromoOrders", icon: "🎁" },
  { key: "MyOrderIncome", icon: "💰" }
];


const viewIncommeMenu =()=>{
 return (
    <>
      {/* 🔥 CSS intégré dans la fonction */}
      <style>
        {`
          .menu-horizontal {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
          }

          .menu-horizontal ul {
            list-style: none;
            padding: 10px 20px;
            margin: 0;
            display: flex;
            gap: 25px;
            background: #f7f7f7;
            border-radius: 8px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          }


          .menu-horizontal li {
            cursor: pointer;
            padding: 8px 14px;
            border-radius: 6px;
            transition: 0.3s ease;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 15px;
            font-weight: 500;
            color: #333;
          }

           .menu-horizontal li {
            cursor: pointer;
            padding: 8px 14px;
            border-radius: 6px;
            transition: 0.3s ease;
            display: flex;
            border-color: #3182ce !important;
            align-items: center;
            gap: 6px;
            font-size: 15px;
            font-weight: 500;
            color: #333;
          }

          @media (max-width: 768px) {
           .menu-horizontal ul {
            width: 100%;
            padding: 10px 10px;
            display: grid;
            gap: 12px;
          }

             .menu-horizontal li {
            transition: 0.3s ease;
            display: flex;
            box-shadow: 0 0 0 2px rgba(188, 190, 192, 0.35) !important;
            gap: 6px;
          }
          }

          .menu-horizontal li:hover {
            background: #e5e5e5;
            transform: translateY(-2px);
          }

          .menu-horizontal li span.icon {
            font-size: 18px;
          }
          .IncommeMenu-active {
            background: #e0f0ffff !important;
            border-color: #3182ce !important;
            box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.35) !important;
            transform: translateY(-2px);
          }
        `}
      </style>

      {/* 🔥 HTML du menu */}
      <nav className="menu-horizontal">
        <ul>
          {sellerMenu.map((item) => (
            <li key={item.key} className={item.key === incommeView ?"IncommeMenu-active" : ""} onClick={() => selectIncomeView(item.key)}>
        <span className="icon">{item.icon}</span>
         {infoSource.language(infoSource, "title", item.key)}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}

    return (
        <Layout
        infoSource ={infoSource}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).wallet.t017}
            className="container-fluid"
            loading={loading}
            SliderPunShow={false}
            setLoading={false}
            {...infoSource?.allSettings?.layout}
        >
        <div style={infoSource.styleNav}>
            {WalletMenu()}
            {/* {incommeL && Assoociate() && viewIncommeMenu()} */}
            {cardSaveSuccess && paymentL && (
              <div className="alert alert-success alert-dismissible fade show mx-auto mt-3" style={{ maxWidth: 950 }} role="status">
                {cardSaveSuccess}
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setCardSaveSuccess("")}></button>
              </div>
            )}
            <Paymentmethodsredesign
    paymentL={paymentL}
    paymentMethods={paymentMethods}
    infoSource={infoSource}
    setAddCards={setAddCards}
    DelPaymentMethod={DelPaymentMethod}
    ButtonEdit={ButtonEdit}
    buttonDefaultCard={buttonDefaultCard}
    onShowPolicy={() => setShowPolicyModal(true)}
    bankAccountsList={bankAccountsList}
    setAddBankAcc={setAddBankAcc}
    DelBankAccount={DelBankAccount}
    ButtonEditBank={ButtonEditBank}
    UpdateBankAccount={UpdateBankAccount}
/>
{CommercialRole() && bankingL && (
  <div className="mx-auto mt-3 px-3" style={{ maxWidth: 1100 }}>
    <WalletBalancePanel openSignal={withdrawSignal} />
  </div>
)}
<AssociatePaymentDashboard
  userInfo={userInfo}
  incommePayroll={incommePayroll}
  getACCStripe={getACCStripe}
  infoSource={infoSource}
  address={address}
  token={token}
  AccountStripeCreate={AccountStripeCreate}
  loadingB={loadingB}
  setAddExBankAcc={setAddExBankAcc}
  setTransferMoneyShow={setTransferMoneyShow}
  onDeleteBank={DelExternalBankAccount}
  onSetDefaultBank={SetDefaultExternalBankAccount}
  onUpdateBank={UpdateExternalBankAccount}
  onEditAccount={EditAccountLink}
  // Providers earn too (dropshipping_seller): the bank management section is
  // for every commercial role, not Seller-branch only.
  Seller={CommercialRole}
  bankingL={bankingL}
/>
            {/* {UserDetailsDD()} */}
<Associateincomedashboard
  infoSource={infoSource}
  sellerMenu={sellerMenu}
  incommeView={incommeView}
  setIncommeView={selectIncomeView}
  my_Order_as_Seller={my_Order_as_Seller}
  my_Seller_Order={my_Seller_Order}
  my_Commision_Orders={my_Commision_Orders}
  my_Promo_Orders={my_Promo_Orders}
  paymentIntentIncome={
    usePaymentIntentIncome
      ? walletSeller?.PaymentIntentIncome
      : null
  }
  getTotal={getTotal}
  inComeSeller={inComeSeller}
  prodFrTransaction={prodFrTransaction}
  elakayFrais={elakayFrais}
  elakayFraisJSON={elakayFraisJSON}
  totalFrais={totalFrais}
  calProfit={calProfit}
  ItemsOrder={ItemsOrder}
  Seller={Seller}
  Assoociate={Assoociate}
  incommeL={incommeL}
  onDateRangeChange={handleChartDateRangeChange}
  usePaymentIntentDashboard={usePaymentIntentIncome}
  incomeResponse={walletSeller}
  incomeLoading={incomeLoading}
  incomeError={incomeError}
  onIncomeRetry={() => laodOrderWalletSeller(token, filtOrders)}
/>
            {/* {incommeView === "MyOrdersAsSeller" &&  MonneyWalletViewSell()}
            {incommeView === "MySellerOrders" && Assoociate() &&  CommissionForMySeller()}
            {incommeView === "MyOrderIncome" &&  Assoociate() && CommissionFromOrders()}
            {incommeView === "MyPromoOrders" &&  Assoociate() && MyPromotionOrders()} */}
            {AddBankAccount()}
            {AddExBankAccount()}
            {SaveCard()}
            {EditCard()}
            {EditBankAccount()}
            {filterOrdersView()}
            {transferMoney()}
            {/* {elakayFraisJSON(my_Order_as_Seller)} */}
                <StripeError
                    laguangeElakay={laguangeElakay}
                    infoSource ={infoSource}
                    listePM_createStripeCusTomer={listePM_createStripeCusTomer}
                    show={show}
                    setShow={setShow}
                />
                {/* < CreditCardType
                /> */}
                     <StripeAccountCreationModal
                  showModal={showStripeModal}
                setShowModal={setShowStripeModal}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
                token={token}
                createStripeAccount={createStripeAccount}
                userType={userType}
                policyData={policyData}
                langCode={langCode}
                // [] = toutes les sections, ou spécifier les IDs ["1", "2", "3"]
                policySectionIds={[]}
            />
            <Modal
                size="lg"
                show={showPolicyModal}
                onHide={() => setShowPolicyModal(false)}
                dialogClassName="modal-90w"
                centered
                aria-labelledby="payment-policy-modal-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="payment-policy-modal-title">
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).paymentPolicy || elakayAutoText("h_d4f5b7a318b2c4", "Payment Policy")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StripeElakayPolicyPage infoSource={infoSource} />
                </Modal.Body>
            </Modal>
                </div>
        </Layout>
    );
};

export default Wallet;
